import BaseService from './base';

class GameService extends BaseService {
  constructor() {
    super();
    const base = this.constructor.init();
    this.$http = base.$http;
  }

  async getGamesAll() {
    const result = await this.get('/game/all');
    return result;
  }

  async getGamesForToday() {
    const result = await this.get('/game/all/today');
    return result;
  }

  async getGamesForDate(date) {
    const result = await this.post('/game/all/fordate', {
      forDate: new Date(date).toISOString(),
    });
    return result;
  }

  async getGameDuels(gameId) {
    const result = await this.get(`duel/find/game/${gameId}`);
    return result;
  }

  async getGame(gameId) {
    const result = await this.get(`game/find/${gameId}`);
    return result;
  }
}

export default new GameService();
